import React from 'react';

import Link from 'utils/localized-link';

import Banner from 'components/sections/banner';
import Layout from 'components/layout';
import SEO from 'components/seo';
import TechnologyHero from 'components/sections/technology-hero';
import TechnologyTimeline from 'components/sections/technology-timeline';


const WEB_APP_URL = process.env.GATSBY_WEB_APP_URL;

const bannerImage = 'create-account.png';

const bannerButtons = [
  {
    external: true,
    linkProps: {
      to: `${WEB_APP_URL}/register`
    },
    light: true,
    noArrow: true,
    small: true,
    text: 'tech.banner.buttons.sign_up'
  },
  {
    linkComponent: Link,
    linkProps: {
      to: '/contacts'
    },
    light: true,
    noArrow: true,
    noBackground: true,
    small: true,
    text: 'tech.banner.buttons.contacts'
  }
];

const TechnologyPage = ({ pageContext: { locale } }) => (
  <Layout locale={locale}>
    <SEO title="tech.title" />
    <TechnologyHero />
    <TechnologyTimeline />
    <Banner
      buttons={bannerButtons}
      image={bannerImage}
      title="tech.banner.title"
      text="tech.banner.text"
    />
  </Layout>
);

export default TechnologyPage;
